module.exports = __webpack_public_path__ + "img/arrow-left.239fe9c.svg";